module.exports = __webpack_public_path__ + "static/media/info-icon.d3c0efcf.svg";